import axios from "axios";
import { getToken, getTenantId, getExternalAccess } from "@/libs/util";
import { curLan, t } from '@/utils/language';
//引入配置文件
import config from "@/config";
axios.defaults.withCredentials = true;
// axios.defaults.headers["Content-Type"] = "application/json;charset=UTF-8";

// api地址
const base =
  process.env.NODE_ENV === "production"
    ? window.$G.SERVER_URL
    : config.baseUrl.dev;

//文件上传基础地址
export const baseUrl = base;

axios.interceptors.request.use(
  config => {
    let token = getToken();
    if (token) {
      config.headers["Authorization"] = token;
    }
    config.headers["language"] = curLan;
    config.headers["tenant-id"] = getTenantId();
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

//get
export const getData = (getUrl, globeVue,noBase) => {
  return Promise.race([
    new Promise((resolve, reject) => {
      axios
        .get(noBase ? getUrl : base + getUrl)
        .then(response => {
          //console.log(response)
          //debugger;
          //无法进入
          if(noBase){
            resolve(response.data);
          }else if (response.data.code != 200) {
            if (response.data.code == 401) {
              // 退出登录
              globeVue && globeVue.$store.commit("logOut");
              // 检查是否为外部接入，决定跳转到哪个登录页面
              const isExternal = getExternalAccess();
              const loginRoute = isExternal ? "external-login" : "login";
              globeVue && globeVue.$router.push({ name: loginRoute });
              resolve({ state: 0, msg: t(isExternal ? 'extraReLogin' : 'reLogin') });
            } else {
              var timerOut = { state: 0, msg: response.data.message };
              resolve(timerOut);
            }
          } else {
            var timerOut = {
              state: 1,
              msg: response.data.message,
              data: response.data.data
            };
            resolve(timerOut);
          }
        })
        .catch(error => {
          resolve({ state: 0, msg: t('intError') });
        });
    }),
    new Promise((resolve, reject) => {
      var timerOut = {
        state: 0,
        msg: t('timeOut')
      };
      setTimeout(() => {
        resolve(timerOut);
      }, 50000);
    })
  ]);
};
//post
//globeVue 全局vue对象
export const postData = (postUrl, param, globeVue,noBase) => {
  return Promise.race([
    new Promise((resolve, reject) => {
      axios
        .post(noBase ? postUrl : base + postUrl, param)
        .then(response => {
          //无法进入
          if (response.data.code != 200) {
            if (response.data.code == 401) {
              // 退出登录
              globeVue.$store.commit("logOut");
              // 检查是否为外部接入，决定跳转到哪个登录页面
              const isExternal = getExternalAccess();
              const loginRoute = isExternal ? "external-login" : "login";
              globeVue.$router.push({ name: loginRoute });
              resolve({ state: 0, msg: t(isExternal ? 'extraReLogin' : 'reLogin') });
            } else {
              var timerOut = { state: 0, msg: response.data.message };
              resolve(timerOut);
            }
          } else {
            resolve(response.data);
          }
        })
        .catch((error, response) => {
          console.log(base + postUrl);
          console.log(param);
          resolve({ state: 0, msg: t('intError') });
        });
    }),
    new Promise((resolve, reject) => {
      var timerOut = {
        state: 0,
        msg: t('timeOut') + postUrl
      };
      setTimeout(() => {
        resolve(timerOut);
      }, 50000);
    })
  ]);
};

// 文件格式
export const upload = (postUrl, param, globeVue) => {
  return Promise.race([
    new Promise((resolve, reject) => {
      axios
        .post(base + postUrl, param, {
          headers: {
            "Content-Type": "multipart/form-data"
          },
          onUploadProgress: globeVue.onUploadProgress // 确保传递进度回调
        })
        .then(response => {
          //无法进入
          if (response.data.code != 200) {
            if (response.data.code == 401) {
              // 退出登录
              globeVue.$store.commit("logOut");
              // 检查是否为外部接入，决定跳转到哪个登录页面
              const isExternal = getExternalAccess();
              const loginRoute = isExternal ? "external-login" : "login";
              globeVue.$router.push({ name: loginRoute });
              resolve({ state: 0, msg: t(isExternal ? 'extraReLogin' : 'reLogin') });
            } else {
              var timerOut = { state: 0, msg: response.data.message };
              resolve(timerOut);
            }
          } else {
            resolve(response.data);
          }
        })
        .catch((error, response) => {
          // console.log(base + postUrl);
          //console.log(param);
          resolve({ state: 0, msg: t('intError') });
        });
    }),
    new Promise((resolve, reject) => {
      var timerOut = {
        state: 0,
        msg: t('timeOut') + postUrl
      };
      setTimeout(() => {
        resolve(timerOut);
      }, 50000);
    })
  ]);
};

export const download = (url, fileName) => {
  return Promise.race([
    new Promise((resolve, reject) => {
      axios.get(base + url, { responseType: "blob" }).then(({ data }) => {
        // 为了简单起见这里blob的mime类型 固定写死了
        let blob = new Blob([data], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click().catch(error => {
          console.error(error);
        });
      });
    }),
    new Promise((resolve, reject) => {
      var timerOut = {
        state: 0,
        msg: t('timeOut')
      };
      setTimeout(() => {
        resolve(timerOut);
      }, 50000);
    })
  ]);
};


// 从 blob 响应中解析后台业务错误信息
const parseBlobError = async (data) => {
  if (!data) return null;
  let json;
  if (data instanceof Blob) {
    try {
      json = JSON.parse(await data.text());
    } catch (e) {
      return null;
    }
  } else if (typeof data === 'object') {
    json = data;
  } else {
    return null;
  }
  if (json.success === false || (json.code && json.code !== 200)) {
    return json.message || null;
  }
  return null;
};

// 支持进度监听的下载方法
export const downloadWithProgress = (url, fileName, onProgress) => {
  let simulatedProgress = 0;
  let simulationTimer = null;
  let realProgressStarted = false;
  
  // 模拟进度：在真实进度到来之前，缓慢增长到90%
  const startSimulation = () => {
    simulationTimer = setInterval(() => {
      if (!realProgressStarted && simulatedProgress < 90) {
        // 使用对数增长，越接近90%增长越慢
        const increment = (90 - simulatedProgress) * 0.05;
        simulatedProgress = Math.min(90, simulatedProgress + increment);
        if (onProgress) {
          onProgress(Math.floor(simulatedProgress), 0, 0);
        }
      }
    }, 200);
  };
  
  // 停止模拟进度
  const stopSimulation = () => {
    if (simulationTimer) {
      clearInterval(simulationTimer);
      simulationTimer = null;
    }
  };
  
  // 开始模拟进度
  startSimulation();
  
  return new Promise((resolve, reject) => {
    axios.get(base + url, {
      responseType: 'blob',
      onDownloadProgress: (progressEvent) => {
        // 真实进度开始了
        if (!realProgressStarted) {
          realProgressStarted = true;
          stopSimulation();
        }
        
        if (onProgress) {
          if (progressEvent.lengthComputable) {
            // 如果知道总大小，计算真实进度
            // 真实进度从模拟进度继续，映射到90%-100%区间
            const realPercent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            const adjustedPercent = Math.floor(simulatedProgress + (realPercent * (100 - simulatedProgress) / 100));
            onProgress(adjustedPercent, progressEvent.loaded, progressEvent.total);
          } else {
            // 如果不知道总大小，从模拟进度继续到100%
            const targetProgress = Math.min(100, simulatedProgress + 10);
            onProgress(Math.floor(targetProgress), progressEvent.loaded, 0);
          }
        }
      }
    })
    .then(async ({ data }) => {
      // 停止模拟进度
      stopSimulation();

      // HTTP 200 但返回 JSON 错误体
      if (data.type && data.type.includes('json')) {
        const errorMsg = await parseBlobError(data);
        if (errorMsg) {
          reject(new Error(errorMsg));
          return;
        }
      }
      
      // 下载完成，通知100%
      if (onProgress) {
        onProgress(100, data.size, data.size);
      }
      
      // 创建blob对象
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      
      // 创建下载链接
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      
      // 清理
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);
      }, 100);
      
      resolve({ success: true, fileName });
    })
    .catch(async (error) => {
      // 停止模拟进度
      stopSimulation();
      const msg = await parseBlobError(error.response?.data) || error.message;
      reject(new Error(msg));
    });
  });
};
